import React, {useEffect} from 'react';

const LanguageSwitch = ({
  selectedLanguage,
  setSelectedLanguage,
  setDefaultLanguage,
  languages = [],
}) => {
  useEffect(() => {
    if (languages?.length > 0) {
      const defaultLanguage = languages.find(lan => lan?.default);
      if (defaultLanguage) {
        setSelectedLanguage(defaultLanguage.code);
        setDefaultLanguage(defaultLanguage.code);
      }
    }
  }, [languages]);

  if (languages?.length <= 1) {
    return null;
  }

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center justify-start w-full  py-2">
        {languages.map(ln => (
          <button
            key={ln.code}
            onClick={() => setSelectedLanguage(ln.code)}
            className={
              selectedLanguage === ln.code
                ? 'px-4 font-bold text-lg py-1.5 rounded-t-lg border-2 border-b-0 border-primary text-primary'
                : 'px-4 py-2 border-b-2 border-primary'
            }
            type="button">
            {ln.name}
          </button>
        ))}
        <div className="x-4 py-5 border-b-2 border-primary w-full"></div>
      </div>
    </div>
  );
};

export default LanguageSwitch;
